import { Route, Redirect, RouteProps } from "react-router-dom";
import PageNotFound from "../../../screens/PageNotFound/PageNotFound";
import urls from "../../constants/UrlConstants";

export const PULSE_LOGIN_REDIRECT_KEY = "pulse.redirectAfterLogin";

export function rememberLoginRedirect(location?: {
  pathname?: string;
  search?: string;
}) {
  const path = String(location?.pathname || "").trim();
  if (!path || path.startsWith("//") || /login|sign-up|signup/i.test(path)) {
    return;
  }
  try {
    sessionStorage.setItem(
      PULSE_LOGIN_REDIRECT_KEY,
      path + String(location?.search || "")
    );
  } catch {
    // ignore storage failures
  }
}

export function consumeLoginRedirect() {
  try {
    const next = sessionStorage.getItem(PULSE_LOGIN_REDIRECT_KEY) || "";
    if (next) sessionStorage.removeItem(PULSE_LOGIN_REDIRECT_KEY);
    return next;
  } catch {
    return "";
  }
}

interface CustomProps extends RouteProps {
  component?: any;
  isLoggedIn: boolean;
  componentName: string;
}

const PrivateRoute = (props: CustomProps) => {
  const { component: Component, isLoggedIn, componentName, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isLoggedIn ? (
          componentName ? (
            <Component {...routeProps} />
          ) : (
            <PageNotFound />
          )
        ) : (
          (() => {
            rememberLoginRedirect(routeProps.location);
            return (
              <Redirect
                to={{
                  pathname: urls.loginViewPath,
                  state: {
                    from: routeProps.location,
                    search: routeProps.location.search,
                  },
                }}
              />
            );
          })()
        )
      }
    />
  );
};

export default PrivateRoute;
